export default "__VITE_ASSET__815a83cf__"